<script>
import UnderDev from '@/views/UnderDev'
export default {
  ...UnderDev
}
</script>
